function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.2003 11.4003V22.8004L36.0004 27.2005V29.4005H29.2003H6.80007H0V27.2005L6.80007 22.6004V11.4003C6.80007 5.20025 11.8001 0.200195 18.0002 0.200195C24.2003 0.200195 29.2003 5.20025 29.2003 11.4003ZM6.80007 27.2005H29.2003V27.0005H32.0003L28.0003 24.4005L27.0003 23.8004V22.6004V11.4003C27.0003 6.40026 23.0002 2.40022 18.0002 2.40022C13.0001 2.40022 9.0001 6.40026 9.0001 11.4003V22.8004V24.0005L8.00009 24.6005L4.00004 27.2005H6.80007ZM22.3997 31.7998C22.3997 34.1998 20.3997 36.1999 17.9997 36.1999C15.5996 36.1999 13.5996 34.1998 13.5996 31.7998H22.3997Z",
  fill: "black"
});

function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.efb25382.svg";
export { ForwardRef as ReactComponent };